import React from 'react';
import DetailPage from '../../components/DetailPage';

export default function ITInfrastructure() {
  return <DetailPage type="product" id="it-infrastructure" />;
}
